import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import {
    FrameworkColumn,
    getTableRowValue,
    ITableCellValueRenderer,
    SafeAny,
    TableColumn,
} from '@pf/shared-common';
import { ValueFormatterService } from '@pf/shared-services';

export interface MultiValueCellRendererProps<T> {
    fields: Array<Pick<TableColumn<T>, 'field' | 'type' | 'headerName'>>;
}

@Component({
    selector: 'pf-multi-value-cell-renderer',
    template: `
        <pf-text type="primary" *ngFor="let field of fieldsWithValue">
            <span class="value-container">
                <strong>{{ field.headerName }}</strong>
                <span>{{ field.value }}</span>
            </span>
        </pf-text>
    `,
    styles: [
        `
            :host {
                pf-text {
                    padding: 0;
                }

                .value-container {
                    display: flex;
                    flex-direction: column;
                    font-size: smaller;
                }
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiValueCellRendererComponent
    implements
        ITableCellValueRenderer,
        MultiValueCellRendererProps<SafeAny>,
        OnChanges
{
    private valueFormatterService = inject(ValueFormatterService);

    @Input() value!: SafeAny;
    @Input() row!: SafeAny;
    @Input() column!: FrameworkColumn;
    @Input() fields: MultiValueCellRendererProps<SafeAny>['fields'] = [];

    fieldsWithValue: { headerName: string; value: string }[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value'] || changes['row'] || changes['fields']) {
            this.updateFieldsWithValue();
        }
    }

    private updateFieldsWithValue(): void {
        this.fieldsWithValue = this.fields
            .map(field => {
                const fieldValue = this.valueFormatterService.format(
                    field.type,
                    getTableRowValue(field, this.row),
                    this.row
                );

                return {
                    headerName: field.headerName,
                    value: fieldValue ?? '',
                };
            })
            .filter(field => field.value);

        console.log('Updated Fields with Value:', this.fieldsWithValue);
    }
}
